import { UAParser } from "ua-parser-js";

export const GEN_UIN_CACHE_KEY = "vtTracker_cache_gen_uin_key";

function generateUin(): number {
    let value = parseInt(localStorage.getItem(GEN_UIN_CACHE_KEY), 10);

    if (Number.isInteger(value)) {
        return value;
    }

    const uaLength = window.navigator.userAgent.length;

    value =
        2 ** 40 + Date.now() + Math.floor(Math.random() * 100000) + uaLength;

    localStorage.setItem(GEN_UIN_CACHE_KEY, String(value));

    return value;
}

export function getUin(): number {
    const mr = document.cookie.match(/\buin=o?(\d+)/);

    const uin = mr && mr[1] ? mr[1].replace(/^0+/, "") : "0";

    return parseInt(uin, 10) || generateUin();
}

export interface UAInfo {
    platform: "ios" | "android" | "other";
    client: "qq" | "qzone" | "wx" | "other";
    qua: string;
    network: string;
    version: string;
    device: string;
    appVersion: string;
}

export function getUAInfo(): UAInfo {
    const ua = window.navigator.userAgent || "";

    const parser = new UAParser(ua).getResult();

    const info: UAInfo = {
        platform: "other",
        client: "other",
        qua: "",
        network: "",
        version: "",
        device: "",
        appVersion: ""
    };

    if (parser.os.name === "Android") {
        info.platform = "android";
        info.version = parser.os.version;
    } else if (parser.os.name === "iOS") {
        info.platform = "ios";
        info.version = parser.os.version;
    } else {
        info.platform = "other";
    }

    info.device = parser.device.model || "";

    /* eslint-disable prefer-destructuring, no-cond-assign */

    const net = ua.match(/NetType\/(.+?)\b/);

    if (net && net[1]) {
        info.network = net[1];
    }

    let app = null;

    if ((app = ua.match(/MicroMessenger\/([0-9.]+)/))) {
        info.client = "wx";
        info.appVersion = app[1];
    } else if ((app = ua.match(/\sQQ\/([0-9.]+)/))) {
        info.client = "qq";
        info.appVersion = app[1];
        // } else if ((app = ua.match(/\sQzone\/([0-9.]+)/))) {
        // info.client = "qzone";
        // info.appVersion = app[1];
    } else if ((app = ua.match(/\sQzone\/(V\S+_\S+_\S+_\S+_\S+_\S+_\S+)/))) {
        info.client = "qzone";
        info.qua = app[1];

        const qzoneVersion = info.qua.match(/_([0-9.]+)_/);

        if (qzoneVersion !== null) {
            info.appVersion = qzoneVersion[1];
        } else {
            info.appVersion = "";
        }
    } else {
        info.client = "other";
    }

    const qua = ua.match(/\s(V\S+_\S+_\S+_\S+_\S+_\S+_\S+)/);

    if (qua !== null) {
        info.qua = qua[1];
    }

    /* eslint-enable prefer-destructuring, no-cond-assign */

    return info;
}
